module.exports = __webpack_public_path__ + "bg_andr_qr.125dd12.png";